export const activeFilterOptions = [
    {value: false, label: 'Active'},
    {value: true, label: 'Inactive'},
]
